import { DeleteIcon } from '@chakra-ui/icons'
import {
  VStack,
  StackDivider,
  Button,
  HStack,
  Spacer,
  IconButton,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { IModelDesignData } from '../../type/designType'
import {
  getAllDesignsState,
  getProductDesignIdFromURL,
  removeDesignState,
} from '../../utils/design/saveLoad'

import { AppContext } from '../../libs/context'

export default function () {
  const { model } = useContext(AppContext)

  const designId = getProductDesignIdFromURL() as string

  const [designs, setDesigns] = useState<IModelDesignData[]>(
    getAllDesignsState(model.current.id)
  )

  return (
    <VStack
      divider={<StackDivider borderColor="gray.200" />}
      spacing={4}
      align="stretch"
    >
      {designs.map(d => (
        <HStack>
          <Button
            onClick={() => {
              document.location.href = `/?p=${model.current.id}&pd=${d.id}`
            }}
            maxW="200px"
            overflowX="hidden"
            justifyContent="left"
          >
            {d.id}
          </Button>
          <Spacer />
          <IconButton
            aria-label="Search database"
            icon={<DeleteIcon />}
            disabled={d.id === designId}
            onClick={() => {
              removeDesignState(d.id)
              setDesigns(getAllDesignsState(model.current.id))
            }}
          />
        </HStack>
      ))}
    </VStack>
  )
}
